import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Movimientos from './components/Movimientos';
import Descargas from './components/Descargas';
import useDocumentHistory from './hooks/useDocumentHistory';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`cdd-agente-tabpanel-${index}`}
            aria-labelledby={`cdd-agente-tab-${index}`}
            style={{ overflow: 'auto', height: 'calc(100% - 49px)' }}
            {...other}
        >
            {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `cdd-agente-tab-${index}`,
        'aria-controls': `cdd-agente-tabpanel-${index}`
    };
}

function HistorialDocumentoContainer({ docId }: any) {
    const { tabValue, data, isLoadingData, isFetchingData, handleChangeTabValue } =
        useDocumentHistory({
            docId
        });

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs className="history-tabs" value={tabValue} onChange={handleChangeTabValue}>
                    <Tab label="Movimientos" {...a11yProps(0)} />
                    <Tab label="Descargas" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={tabValue} index={0}>
                <Movimientos items={data} loading={isLoadingData || isFetchingData} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={1}>
                <Descargas items={data} loading={isLoadingData || isFetchingData} />
            </CustomTabPanel>
        </Box>
    );
}

export default HistorialDocumentoContainer;
